<ng-container *ngIf="product$ | async as product">
  <div class="c column">
    <h2 class="text-xl font-bold mt-2">{{ product.title }}</h2>
    <span class="mt-1 color-light" *ngIf="product.artbez2">{{ product.artbez2 }}</span>
    <span class="mt-1 color-light" *ngIf="product.artbez3">{{ product.artbez3 }}</span>
  </div>

  <section class="soft-section mt-3 pb-2">
    <div class="c row center-v no-wrap">
      <lib-product-detail-field
        class="mr-2"
        [label]="'#PRODUCT_SCAN.DETAIL.VKP'"
        [value]="product.detailverkaufpriceartstamm?.gross"
        [businessCardPrice]="product?.businesscardpriceartstamm?.gross"
        [valueType]="'currency'">
      </lib-product-detail-field>
      <lib-product-detail-field *ngIf="(product.detailverkaufpriceidentnummer || product?.businesscardpriceidentnummer)"
        class="ml-2"
        [label]="'#PRODUCT_SCAN.DETAIL.VKP'"
        [value]="product.detailverkaufpriceidentnummer?.gross"
        [businessCardPrice]="product?.businesscardpriceidentnummer?.gross"
        [valueType]="'currency'">
      </lib-product-detail-field>
    </div>


    <div class="c row center-v no-wrap">
      <div class="c column center-v no-wrap info-box mt-3 mr-2">
        <span class="overline-list custom-color-tertiary mb-1">{{ '#PRODUCT_SCAN.DETAIL.NUMBER' | translate }}</span>
        <div class="color-light">{{product.number}}</div>
      </div>
      <div class="c column center-v no-wrap info-box mt-3 ml-2">
        <span class="overline-list custom-color-tertiary mb-1">{{ '#PRODUCT_SCAN.DETAIL.ID' | translate }}</span>
        <div class="color-light">{{product.identnumber === '' ? '-' : product.identnumber}}</div>
      </div>
    </div>

    <div class="color-light mb-4">
      <ng-container *ngIf="(filePaths$ | async)?.length; else placeholder">
        <div class="info-box-image dead-center" *ngFor="let path of filePaths$ | async">
          <img class="fill-container" [attr.src]="path | secureImage | async" alt="product image">
        </div>
      </ng-container>
      <ng-template #placeholder>
        <div class="info-box-image dead-center mb-4">
          <span class="text-sm color-light">{{ '#PRODUCT_SCAN.DETAIL.NO_IMAGE' | translate }}</span>
        </div>
      </ng-template>
    </div>
  </section>
</ng-container>


